import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgZorroAntdModule }from '../../ng-zorro-antd/ng-zorro-antd.module';

import { UsuarioComponent } from './usuario.component';
import { UsuarioLancamentoComponent } from './usuario-lancamento/usuario-lancamento.component';

@NgModule({
  declarations: [UsuarioComponent, UsuarioLancamentoComponent],
  imports: [
    CommonModule,
    FormsModule, 
    ReactiveFormsModule,
    RouterModule,
    BrowserModule,
    NgZorroAntdModule,
  ]
})
export class UsuarioModule { }
